<template>
  <div class="car-wrap">
    <div class="hot">
      <div class="title">热门品牌</div>
      <div class="list" v-if="data.hot_brands">
        <div class="item" v-for="(item, index) in data.hot_brands" :key="index">
          <div @click="done(item.name,item.brand_id)">
            <div class="text">
            {{item.name}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="group" v-if="data.brand_list">
      <div v-for="(item, alpha) in data.brand_list" :key="alpha">
        <div class="alpha" :ref="alpha" :id="alpha">{{alpha}}</div>
        <div class="list">
          <div class="item border-bottom" @click="sub(subitem.name,subitem.brand_id,subitem.brand_rela)" v-for="(subitem, index) in item" :key="index">{{subitem.name}}</div>
        </div>
      </div>
    </div>
    <div class="alpa-list" v-if="data.letters">
      <div v-for="item in data.letters" :key="item" @click="jump(item)">{{item}}</div>
    </div>
    <div class="mask" v-show="showSub" @click="showSub=false"></div>
    <div class="sub-car" :class="{in: showSub}">
      <div class="title">选择车系</div>
      <div class="item border-bottom" v-for="(item, index) in subList" :key="index" @click="done(brandName + ' ' + item.model_name,item.brand_id_bbs, item.brand_rela_id)">{{item.model_name}}</div>
    </div>
    <!-- 加载中 -->
    <loading v-show="loading"></loading>
  </div>
</template>

<script>
import {RES_OK} from '@/api/config'
import {getBrandInfo, pushFilter, Brand} from '@/api/search'
import Loading from '../base/loading/loading.vue'
// getBoundingClientRect
export default {
  components: {
    Loading
  },
  data() {
    return {
      loading: false,
      showSub: false,
      data: {},
      subList: [], // 子品牌的列表
      brandId: '',
      brandName: ''
    }
  },
  created() {
    this.loading = true
    getBrandInfo().then(({data}) => {
      if (data.code === RES_OK) {
        this.data = data.data
      }
      this.loading = false
    })
  },
  methods: {
    jump(letter) {
      const ele = this.$refs[letter] && this.$refs[letter][0]
      if (ele && ele.offsetTop) {
        document.body && (document.body.scrollTop = ele.offsetTop)
        document.documentElement && (document.documentElement.scrollTop = ele.offsetTop)
      }
    },
    sub(brandName, brandId, subList) {
      this.brandId = brandId
      this.brandName = brandName
      if (subList && subList.length > 0) {
        this.subList = subList
        this.showSub = true
      } else {
        this.done(brandName, brandId)
      }
    },
    done(a, b, c) {
      // 选择了热门品牌
      // 选择了车系
      console.log(a, b, c)
      pushFilter(Brand, {
        name: a,
        brand_id: b,
        brand_rela_id: c
      })
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .car-wrap{
    color #292929
    background #efeff3
    position relative
  }
  .hot{
    background #ffffff
    padding 0 size(30)
    overflow hidden
    .title{
      margin size(30) 0 size(44)
    }
    .list{
      &:after{
        content ' '
        display block
        height 0
        clear both
      }
      padding-right size(20)
      margin-left -6%
      padding-bottom size(24)
      .item{
        margin-left 6%
        width 14%
        float left
        margin-bottom size(30)
        >div{
          position relative
          width 100%
          padding-bottom 100%
          background #eee
          border-radius 50%
          overflow hidden
        }
        .text{
          position absolute
          left 50%
          top 50%
          width 70%
          text-align center
          transform translate(-50%, -50%)
          font-size size(26)
          line-height 1.3
        }
      }
    }
  }
  .group{
    .alpha{
      padding: 0 size(20)
      line-height size(50)
      font-size size(26)
    }
    .list{
      background #fff
      padding-left size(30)
      line-height size(88)
      font-size size(28)
      .item{
        &.active{
          background #d8d8d8
        }
      }
    }
  }
  .alpa-list{
    position fixed
    z-index 9
    top 50%
    right 0
    transform translateY(-50%)
    text-align center
    width size(50)
    font-size size(18)
    >div{
      padding size(10) 0
    }
  }
  .mask{
    position fixed
    left 0
    right 0
    top 0
    bottom 0
    z-index 98
  }
  .sub-car{
    position fixed
    z-index 99
    top 0
    bottom 0
    right size(-460)
    width size(450)
    background #fff
    overflow-y scroll
    text-align center
    box-shadow: -1px 0px 6px 2px rgba(0,0,0,0.09)
    transition right .2s ease-in
    &.in{
      right 0
    }
    .title{
      background #efeff3
      line-height size(52)
      font-size size(28)
    }
    .item{
      line-height 1.4
      font-size size(30)
      padding size((80 - 30 * 1.4) / 2) 0
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/search/car-model.vue